// extracted by mini-css-extract-plugin
export default {"price_wrapper":"PriceSection_price_wrapper__BUZMe","flex":"PriceSection_flex__kCm5S","action_button":"PriceSection_action_button__BxRxV"};